import React, { Component } from 'react'
import PropTypes from 'prop-types'
import css from '../select-item/style.css'

export default class SelectMulti extends Component {
  toggleVal (val, e) {
    if (e) e.preventDefault()

    let currentValues = Array.isArray(this.props.value) ? this.props.value.slice(0) : []

    const index = currentValues.indexOf(val)
    if (index === -1) {
      if (this.props.single) {
        currentValues = [val]
      } else {
        currentValues.push(val)
      }
    } else {
      if (this.props.single) {
        return
      } else {
        currentValues.splice(index, 1)
      }
    }

    this.props.onChange(currentValues)
  }

  render () {
    const currentValues = this.props.value || []
    const classNames = ['multi-container', this.props.className ? this.props.className : '']
    let optionClassNames

    return (
      <div className={classNames.join(' ')}>
        <div className={css.container}>
          {this.props.options.map((option, i) => {
            optionClassNames = [
              css.option,
              currentValues && currentValues.includes(option.value) ? css.active : '',
              option.disabled ? css.disabled : ''
            ]
            return (
              <div id={option.value} key={i} onClick={option.disabled ? null : this.toggleVal.bind(this, option.value)} className={optionClassNames.join(' ')}>
                {option.label}
              </div>
            )
          })}
        </div>
      </div>
    )
  }
}

SelectMulti.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.bool
      ]),
      label: PropTypes.string,
      disabled: PropTypes.bool
    })
  ).isRequired,
  value: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.bool
    ])
  ),
  single: PropTypes.bool,
  onChange: PropTypes.func.isRequired
}



// WEBPACK FOOTER //
// ./src/components/select-multi/index.js